/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import { useAgencyInfo } from 'context/agency'
import { Roles } from 'enums/user'
import { useNavigate } from 'react-router-dom'

export default function DataTableData() {
  const AppService = useAppServices()
  const [List, setList] = useState([])
  const [teamTags, setTeamTags] = useState([])
  const [apps, setApps] = useState([])

  const [loader, setloader] = useState(true)
  const [agency] = useAgencyInfo()
  const navigate = useNavigate()

  const getTeamsTags = async () => {
    const { response } = await AppService.team_tags.get({})
    if (response) {
      setTeamTags(response.data)
      setloader(false)
    } else {
      setloader(false)
    }
  }
  const getAllApps = async () => {
    const { response } = await AppService.app.superadmin_apps({})
    if (response) {
      // console.log(response.data, "response")
      setApps(response.data)
    } else {
    }
  }

  const getCategories = async () => {
    const { response } = await AppService.user.GetTeam({
      query: `role=${Roles.SUPERADMIN}&agency_id=${agency._id}`,
      toaster: false,
    })
    console.log(response, 'request_app')
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setloader(false)
  }

  const onLoad = () => {
    getCategories()
    getTeamsTags()
    getAllApps()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.auth.delete({
      query: `id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])
  return {
    loader: loader,
    teamTags: teamTags,
    apps: apps,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'username' },
        { Header: 'Roles', accessor: 'roles' },
        { Header: 'Tags', accessor: 'tags' },
        { Header: 'Tasks', accessor: 'tasks' },
        { Header: 'Email', accessor: 'email' },

        { Header: 'Action', accessor: 'action' },
      ],

      rows: List.map((data) => ({
        username: data?.username,
        roles: data?.roles.join(', '),
        tags: data?.tags?.map((item) => {
          return item?.label + " - "
        }),
        tasks: data?.tasksInProgress,
        email: data?.email,

        action: (
          <MDBox>
            <EditModal teamTags={teamTags} data={data} apps={apps} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="info"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => navigate(`./${data?._id}`)}
            >
              View
            </MDButton>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
